module.exports = __webpack_public_path__ + "static/media/53.e577819b.jpg";